import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import axios from "./axiosConfig"; // adjust path if needed
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "AdoptLink | Login";
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // const res = await axios.post('http://localhost:8080/api/users/login', formData);
      const res = await axios.post('/api/users/login', formData);

      localStorage.setItem("user", JSON.stringify(res.data)); // store session
      setMessage(`Welcome, ${res.data.name}!`);
      navigate('/dashboard'); // redirect to dashboard
    } catch (err) {
      setMessage('Login failed. Please check your email and password.');
    }
  };


  return (
    <div className="login-container">
      <header>
        <h1>AdoptLink</h1>
      </header>

      <h2>🔐 Login</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" name="email" placeholder="Email" onChange={handleChange} required /><br /><br />
        <input type="password" name="password" placeholder="Password" onChange={handleChange} required /><br /><br />
        <button type="submit">Login
          <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M480-144v-72h264v-528H480v-72h264q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H480Zm-72-168-51-51 81-81H144v-72h294l-81-81 51-51 168 168-168 168Z"/></svg>
        </button>
      </form>
      {message && <p>{message}</p>}

      <p>Don’t have an account?</p>
      <button onClick={() => navigate('/')}>Go to Register</button>
    </div>
  );
}

export default Login;
